"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _StyleConfig = require("../utils/StyleConfig");
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _FieldsetConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-concur_android.css") : void 0);
var _FieldsetConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-concur_default.css") : void 0);
var _FieldsetConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-concur_gateway.css") : void 0);
var _FieldsetConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-concur_ios.css") : void 0);
var _FieldsetSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-sap_fiori_3_dark.css") : void 0);
var _FieldsetSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-sap_fiori_3_hcb.css") : void 0);
var _FieldsetSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-sap_fiori_3_hcw.css") : void 0);
var _FieldsetSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-sap_fiori_3.css") : void 0);
var _FieldsetSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-sap_horizon_dark.css") : void 0);
var _FieldsetSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-sap_horizon_hcb.css") : void 0);
var _FieldsetSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-sap_horizon_hcw.css") : void 0);
var _FieldsetSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset-sap_horizon.css") : void 0);
var _excluded = ["children", "className", "classNameMap", "classicFieldset", "disabled", "formId", "hideLegend", "legend", "muted"];
var styles = {
  concur_android: _FieldsetConcur_android.default,
  concur_default: _FieldsetConcur_default.default,
  concur_gateway: _FieldsetConcur_gateway.default,
  concur_ios: _FieldsetConcur_ios.default,
  sap_fiori_3_dark: _FieldsetSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _FieldsetSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _FieldsetSap_fiori_3_hcw.default,
  sap_fiori_3: _FieldsetSap_fiori_.default,
  sap_horizon_dark: _FieldsetSap_horizon_dark.default,
  sap_horizon_hcb: _FieldsetSap_horizon_hcb.default,
  sap_horizon_hcw: _FieldsetSap_horizon_hcw.default,
  sap_horizon: _FieldsetSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-fieldset';

/**
 * **Fieldset** is used to give semantic meaning to a group of elements
 * inside a form (_e.g._ Billing or Shipping Address).
 * Grouping fields together into a **Fieldset** also provides styling and accessibility benefits.
 */
var Fieldset = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classnames;
  var children = props.children,
    className = props.className,
    classNameMap = props.classNameMap,
    classicFieldset = props.classicFieldset,
    disabled = props.disabled,
    formId = props.formId,
    hideLegend = props.hideLegend,
    legend = props.legend,
    muted = props.muted,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(classNameMap);
  var classes = classnames(className, _StyleConfig.CSS_PREFIX, CSS_BLOCK, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--classic"), classicFieldset && !muted), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--muted"), muted), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--no-legend"), hideLegend), _classnames));
  var legendClasses = classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "__legend"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--screen-reader-only"), hideLegend));
  var addChildProps = function addChildProps(child, childProps) {
    var componentsThatCanBeDisabled = ['Button', 'Checkbox', 'Link', 'Radio', 'Tab'];
    var componentsThatCanBeDisabledAndSupportLayout = ['DatePicker', 'InputField', 'RadioGroup', 'Select', 'TimePicker', 'Slider', 'TextArea'];
    if (componentsThatCanBeDisabled.indexOf(child.displayName) !== -1) {
      return {
        disabled: !!disabled || childProps.disabled
      };
    }
    if (componentsThatCanBeDisabledAndSupportLayout.indexOf(child.displayName) !== -1) {
      return {
        disabled: !!disabled || childProps.disabled
      };
    }
    return {};
  };
  return /*#__PURE__*/_react.default.createElement("fieldset", (0, _extends2.default)({}, otherProps, {
    className: classes,
    disabled: disabled,
    form: formId,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("legend", {
    className: legendClasses
  }, legend), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.default.Provider, {
    value: addChildProps
  }, children));
});
Fieldset.displayName = 'Fieldset';
Fieldset.propTypes = {
  /** Text placed at the top of the **Fieldset** to identify group content. */
  legend: _propTypes.default.node.isRequired,
  /** A collection of elements that are to be contained within the **Fieldset**. */
  children: _propTypes.default.node,
  /** Set to `true` to use classic **Fieldset** styling. */
  classicFieldset: _propTypes.default.bool,
  /** Any custom classes to add to the `<fieldset>` element. */
  className: _propTypes.default.string,
  /** Sets the `disabled` attribute on the `<fieldset>` element.
   * It also disables any inputs, links, buttons or select controls
   * within that **Fieldset** by setting appropriate HTML attributes, i.e.
   * `disabled` or `aria-disabled`, on them. */
  disabled: _propTypes.default.bool,
  /** Relates the **Fieldset** to the parent form based on id. */
  formId: _propTypes.default.string,
  /** Set to `true` to hide the **Fieldset** legend. Hiding the legend only hides
   * it visually -- it is still used for accessibility reasons. */
  hideLegend: _propTypes.default.bool,
  /** Sets the `id` attribute on the `<fieldset>` element. */
  id: _propTypes.default.string,
  /** Set to `true` to use muted **Fieldset** styling. */
  muted: _propTypes.default.bool,
  /** Sets the `name` attribute on the `<fieldset>` element. */
  name: _propTypes.default.string
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(Fieldset);
exports.default = _default;